import { extent } from 'd3-array'
import { scaleLinear } from 'd3-scale'

export default class ColorPalette {
    constructor({ type = 'totalPitches', data = [], customPalette = [] }) {
        let palette = ['#3661AD', '#ffffff', '#D82129', '#8e161b']
        this.color = () => '#000 '

        if (customPalette && customPalette.length > 0) {
            palette = customPalette
        }
        this.extent = extent(data, (d) => Number(d.calculations[type]))
        const [min, max] = this.extent
        this.min = min
        this.max = max

        if (this.max || this.min || (this.max === 0 && this.min === 0)) {
            if (type === 'totalPitches') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([0, this.max / 2, this.max])
            } else if (type === 'percent' || type === 'kPercent') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([0, 15, 30])
                    .clamp(true)
            } else if (type === 'ba') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([0, 0.25, 0.333, 1])
            } else if (type === 'woba' || type === 'slg' || type === 'xWoba') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([0, 0.32, 0.65, 1.0])
                    .clamp(true)
            } else if (type === 'avgExitVelocity') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([60, 85, 100])
                    .clamp(true)
            } else if (type === 'avgLaunchAngle') {
                const laPalette = [
                    '#3661AD',
                    '#ffffff',
                    '#D82129',
                    '#ffffff',
                    '#3661AD',
                ]
                this.color = scaleLinear()
                    .range(laPalette)
                    .domain([-5, 10, 20, 30, 45])
                    .clamp(true)
            } else if (type === 'releaseSpinRate') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([1000, 2000, 2800, 3000])
                    .clamp(true)
            } else if (type === 'releaseSpeed') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([70, 88, 96, 100])
                    .clamp(true)
            } else if (type === 'batSpeed' || type === 'batSpeedCompetitive') {
                this.color = scaleLinear()
                    .range(['#3661AD', '#ffffff', '#D82129'])
                    .domain([62, 71, 80])
                    .clamp(true)
            } else if (
                type === 'swingLength' ||
                type === 'swingLengthCompetitive'
            ) {
                this.color = scaleLinear()
                    .range(['#3661AD', '#ffffff', '#D82129'])
                    .domain([8.2, 7.3, 6.4])
                    .clamp(true)
            } else if (type === 'swing_miss_percent') {
                this.color = scaleLinear()
                    .range(palette)
                    .domain([0, 25, 50, 100])
            } else if (type === 'runExp' || type === 'pitcherRunExp') {
                // Max could be zero...
                // Positive Values are good (red) either way
                const maxAbs = Math.max(Math.abs(min), Math.abs(max))
                this.color = scaleLinear()
                    .range(['#3661AD', '#ffffff', '#D82129'])
                    .domain([-maxAbs, 0, maxAbs])
                    .clamp(true)
            }
        } else {
            this.color = scaleLinear().range(['#ededed', '#ededed', '#ededed'])
        }
    }
}
